import React, { useRef } from "react";
import Hero from "./Hero";
import Trainers from "./Trainers";
import Community from "../../components/Community";
import Programs from "../../components/Programs";

const FoodWaste = () => {
    const scrollToRef = useRef(null);

    return (
        <>
            <Hero scrollToRef={scrollToRef} />
            <Programs
                scrollToRef={scrollToRef}
                classNameTitle="h4"
                title="Reffo helps connect diners with the product that isn't moving as fast as you planned. You can even link up with local charities."
            />
            <Trainers />
            <Community />
        </>
    );
};

export default FoodWaste;
